'use client';

import { useTranslations } from 'next-intl';

import { FormattedMessage } from '@flipster/i18n';
import { Dialog } from '@flipster/react/design-system/dialog';

interface VotingOpensSoonDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onExit?: () => void;
}

export const VotingOpensSoonDialog = ({ isOpen, onClose, onExit }: VotingOpensSoonDialogProps) => {
  const t = useTranslations('Campaign.r260123');

  return (
    <Dialog.Root isOpen={isOpen} onExit={onExit}>
      <Dialog.Title label={t('Voting_opens_soon')} />
      <Dialog.Content>
        <FormattedMessage id='Campaign.r260123.Voting_before_campaign_dialog' />
      </Dialog.Content>
      <Dialog.Footer>
        <Dialog.Button hierarchy='primary' label='OK' onClick={onClose} />
      </Dialog.Footer>
    </Dialog.Root>
  );
};
